module.exports = "./img/6b3f980aa8981dea1bc2ed54f9b97c95.jpg";